module.exports = "<h1 id=\"徽标--m-badge\">徽标  m-badge</h1>\n";